import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n      background-color: ",
        ";\n      color: ",
        ";\n\n      &.active,\n      &:hover {\n        background-color: ",
        ";\n        color: ",
        ";\n      }\n    "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n      background-color: ",
        ";\n      color: ",
        ";\n\n      &.active,\n      &:hover {\n        background-color: ",
        ";\n        color: ",
        ";\n      }\n    "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _tagged_template_literal([
        "\n      color: ",
        ";\n      border: 1px solid ",
        ";\n      &.active,\n      &:hover {\n        background-color: ",
        ";\n        color: ",
        ";\n      }\n    "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: auto;\n  padding: 9px 16px;\n\n  border-radius: 6px;\n  font-weight: 600;\n  letter-spacing: -0.14px;\n\n  &.disabled {\n    background-color: ",
        " !important;\n    color: ",
        " !important;\n  }\n\n  ",
        "\n  ",
        "\n\n	\n		",
        "\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
import styled, { css } from "styled-components";
import Link from "next/link";
export const LinkVariants = {
    plain: "plain",
    outlined: "outlined",
    soft: "soft",
    solid: "solid"
};
const FilledLink = styled(Link).withConfig({
    componentId: "sc-d451f70b-0"
})(_templateObject3(), (props)=>props.theme.new.colors.sol_gray_100, (props)=>props.theme.new.colors.sol_gray_300, (props)=>props.variant === LinkVariants.solid && css(_templateObject(), (props)=>props.theme.new.colors.sol_indigo_500, (props)=>props.theme.new.colors.white, (props)=>props.theme.new.colors.sol_indigo_600, (props)=>props.theme.new.colors.white), (props)=>props.variant === LinkVariants.soft && css(_templateObject1(), (props)=>props.theme.new.colors.sol_indigo_100, (props)=>props.theme.new.colors.sol_indigo_600, (props)=>props.theme.new.colors.sol_indigo_200, (props)=>props.theme.new.colors.sol_indigo_600), (props)=>props.variant === LinkVariants.outlined && css(_templateObject2(), (props)=>props.theme.new.colors.sol_indigo_500, (props)=>props.theme.new.colors.sol_indigo_500, (props)=>props.theme.new.colors.sol_indigo_50, (props)=>props.theme.new.colors.sol_indigo_500));
export default FilledLink;
